import CompanyBillingDetailsRepository from './CompanyBillingDetailsRepository';

export * from './CompanyBillingDetailsRepository';

export default CompanyBillingDetailsRepository;
